/* eslint-disable linebreak-style */
import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.feature-cards-carousel',
        slides: '.feature-cards-carousel__slides',
        slide: '.feature-cards-carousel__slide',
        next: '.feature-cards-carousel__next',
        prev: '.feature-cards-carousel__prev',
    },
    classNames: {
        arrows: 'feature-cards-carousel__arrows',
        noInit: 'feature-cards-carousel--no-init',
        medium: 'feature-cards-carousel--medium',
        small: 'feature-cards-carousel--small',
    },
    dataAttributes: {
    },
    smallSliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: Breakpoints.BREAKPOINTS.MD,
                settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: Breakpoints.BREAKPOINTS.LG,
                settings: {
                    slidesToShow: 4.2,
                    slidesToScroll: 1,
                },
            },
        ],
    },

    sliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        variableWidth: false,
        accessibility: false,
        responsive: [
            {
                breakpoint: Breakpoints.BREAKPOINTS.SM,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: Breakpoints.BREAKPOINTS.MD,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
        ],
    },
    mediumSliderConfig: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        mobileFirst: true,
        autoplay: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: Breakpoints.BREAKPOINTS.LG,
                settings: {
                    arrows: true,
                },
            },
        ],
    },
    easeTime: 0.2,
    sliderConfigDuo: {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 750,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: false,
        variableWidth: false,
    },
};

class FeatureCardCarousel {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._isSlider = false;
        this._currentIndex = 0;
    }

    init() {
        if (this._$rootElement.hasClass(config.classNames.noInit)) return;
        if (this._$rootElement.hasClass(config.classNames.small) && this._$rootElement.find('.feature-cards-carousel__slide-outer').length <= 4) {
            const slide = this._$rootElement.find('.feature-cards-carousel__slide-outer').length;
            this._$rootElement.addClass(config.classNames.noInit);
            this._$rootElement.addClass(`feature-cards-carousel--${slide}`);
            return;
        }

        if (this._$rootElement.hasClass(config.classNames.small)) {
            $('.feature-cards-carousel__slide-outer').attr('tabindex', -1);
            if ($('.feature-card').hasClass('feature-card--has-link')) {
                const slidewithoutOverlayLink = $('.feature-card--has-link').closest('.feature-cards-carousel__slide-outer');
                $(slidewithoutOverlayLink).attr('tabindex', 0);
                $(slidewithoutOverlayLink).attr('aria-hidden', 'false');
            }
        }

        this._elements = this._getDomElements();
        this._addEventListener();
        this._setSliderState();
        this._$rootElement.addClass(`feature-cards-carousel--${this._elements.$slide.length}`);

        this._elements.$next.on('click keydown', (event) => {
            if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
                this._elements.$slides.slick('slickNext');
                this._updateArrows();
            }
        });
        this._elements.$prev.on('click keydown', (event) => {
            if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
                this._elements.$slides.slick('slickPrev');
                this._updateArrows();
            }
        });
    }

    _updateArrows() {
        const { $slides, $next, $prev } = this._elements;
        if (!$slides.hasClass('slick-initialized')) {
            $prev.hide();
            $next.hide();
            return;
        }
        $prev.show();
        $next.show();
        const slick = $slides.slick('getSlick');
        if (slick) {
            const isFirstSlide = slick.currentSlide === 0;
            const isLastSlide = slick.currentSlide >= slick.slideCount - slick.options.slidesToShow;
            $prev.attr('aria-disabled', isFirstSlide).toggleClass('disabled', isFirstSlide);
            $next.attr('aria-disabled', isLastSlide).toggleClass('disabled', isLastSlide);
        }
    }

    _getSliderConfig() {
        if (this._$rootElement.hasClass('feature-cards-carousel--2')) {
            return config.sliderConfigDuo;
        }
        // init for small cards slider
        // eslint-disable-next-line max-len
        if (!this._$rootElement.hasClass(config.classNames.noInit) && this._$rootElement.hasClass(config.classNames.small)) {
            return config.smallSliderConfig;
        }

        return config.sliderConfig;
    }

    _setSliderState() {
        // init for medium cards slider
        // eslint-disable-next-line max-len
        if(!this._$rootElement.hasClass(config.classNames.noInit) && this._$rootElement.hasClass(config.classNames.medium) && !this._elements.$slides.hasClass('slick-initialized')) {
            this._elements.$slides.slick(config.mediumSliderConfig);
            this._updateArrows();
            return;
        }

        if (Breakpoints.isBreakpointOrLarger('md')) {
            if (this._elements.$slide.length > 3 && !this._elements.$slides.hasClass('slick-initialized')) {
                this._elements.$slides.slick(this._getSliderConfig());
                this._elements.$arrows.addClass('show');
            } else if (this._elements.$slide.length <= 3 && this._elements.$slides.hasClass('slick-initialized')) {
                this._elements.$slides.slick('unslick');
                this._elements.$arrows.removeClass('show');
            }
        } else if (this._elements.$slide.length > 1 && !this._elements.$slides.hasClass('slick-initialized')) {
            this._elements.$slides.slick(this._getSliderConfig());
            this._elements.$arrows.addClass('show');
        }
        this._updateArrows();
    }

    _getDomElements() {
        return {
            $slides: this._$rootElement.find(config.selectors.slides),
            $slide: this._$rootElement.find(config.selectors.slide),
            $next: this._$rootElement.find(config.selectors.next),
            $prev: this._$rootElement.find(config.selectors.prev),
            $arrows: this._$rootElement.find(`.${config.classNames.arrows}`),
        };
    }

    _addEventListener() {
        const _this = this;
        this._elements.$slides.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            if (event.target !== _this._elements.$slides[0]) return;
            this._currentIndex = nextSlide;
        });

        this._elements.$slides.on('wheel', (event) => {
            // eslint-disable-next-line max-len
            if ((event.originalEvent.deltaX <= -10 && !event.shiftKey) || (event.originalEvent.deltaY <= -10 && event.shiftKey)) {
                this._elements.$slides.slick('slickNext');
            }
            // eslint-disable-next-line max-len
            if ((event.originalEvent.deltaX >= 10 && !event.shiftKey) || (event.originalEvent.deltaY >= 10 && event.shiftKey)) {
                this._elements.$slides.slick('slickPrev');
            }
        });

        this._elements.$slides.on('mousedown', () => {
            _this._elements.$slides.one('mouseup', () => {
                _this._elements.$slides.off('mousemove');
            }).on('mousemove', (e) => {
                for (let index = 0; index < document.querySelectorAll('.feature-cards-carousel__slide-outer').length; index++) {
                    const element = document.querySelectorAll('.feature-cards-carousel__slide-outer')[index];
                    element.style['pointer-events'] = 'none';
                }
                 e.preventDefault();
            });
        });

        this._elements.$slides.on('mouseup', () => {
            for (let index = 0; index < document.querySelectorAll('.feature-cards-carousel__slide-outer').length; index++) {
                const element = document.querySelectorAll('.feature-cards-carousel__slide-outer')[index];
                element.style['pointer-events'] = 'auto';
            }
        });

        this._elements.$slides.on('afterChange', () => {
            this._updateArrows();
        });

        Breakpoints.onBreakpointChange(() => {
            this._setSliderState();
        });
    }
}

moduleRegistry.registerModule('FeatureCardCarousel', FeatureCardCarousel);
moduleRegistry.autoApplyModule('FeatureCardCarousel', config.selectors.root);
